export default {
  data() {
    return {
      mixinsrcLeafMethodNames: {},
    };
  },
  methods: {
    rcLeaf(obj, path) {
      const splitPaths = path.split('.');
      let res = obj;
      for (let i = 0; i < splitPaths.length; i += 1) {
        if (res[splitPaths[i]] === undefined || res[splitPaths[i]] === null) { return null; }
        res = res[splitPaths[i]];
      }
      return res;
    },
  },
};
